import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02054c67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-modal-container" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "bus-stop-name" }
const _hoisted_4 = { class: "schedule-table" }
const _hoisted_5 = { class: "hour" }
const _hoisted_6 = { class: "times" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "시간표",
      shouldHideBackButton: true,
      onOnClickClose: $setup.onCloseTimeTable
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($props.busStop.name), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departureTimeByHour, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["row", {
            'first-row-only': $setup.departureTimeByHour.length === 1,
          }]),
            key: row.hour
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(row.hour), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.minutes, (minute) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "time",
                  key: `${row.hour}:${minute}`
                }, _toDisplayString(row.hour) + ":" + _toDisplayString(minute), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}